
import React from 'react';

const ClientsSection = () => {
  const clients = [
    { id: 1, name: 'Amdocs' },
    { id: 2, name: 'Astro' },
    { id: 3, name: 'Genpact' },
    { id: 4, name: 'IBM' },
    { id: 5, name: 'Omdena' },
    { id: 6, name: 'PETRONAS Digital' },
    { id: 7, name: 'PwC India' },
    { id: 8, name: 'Reliance Industries Ltd.' },
    { id: 9, name: 'Summarize.AI' },
    { id: 10, name: 'Walmart' }
  ];
  
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#0EA5E9] to-[#6366F1]">
          Our Candidates Have Experience With
        </h2>
        <p className="text-gray-600 text-center max-w-2xl mx-auto mb-12">
          Top talent from world-class organizations ready to work with AI
        </p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-12">
          {clients.map((client) => (
            <div 
              key={client.id} 
              className="flex items-center justify-center p-4 h-24 border border-gray-200 rounded-lg hover:border-[#0EA5E9]/30 transition-all duration-300 hover:shadow-md group"
            >
              <span className="text-gray-800 font-medium text-lg group-hover:text-[#0EA5E9] transition-colors duration-300">
                {client.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
